import React, { useState } from 'react';
import { ArrowDown, ChevronDown } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { enums } from '../helpers/common';
import { colors } from '../helpers/meta';
import { Link } from 'react-router-dom';
import { setLogout } from '../redux/actions/auth';

const ProfileMenu = (props) => {
  const user = useSelector(state => state.auth.user);
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const dispatch = useDispatch();
  const toggle = () => {
    setDropdownOpen(!dropdownOpen);
  }
  const logout = () => {
    dispatch(setLogout(false))
  }

  return (
    <Dropdown id="profile-menu" isOpen={dropdownOpen} toggle={toggle} style={{border: `1px solid var(--silver)`, borderRadius: "20px"}}>
      <DropdownToggle nav>
        {
          !props.logo && !props.logo.length > 0 &&
          <span style={{color: colors.dark}}>{props.title}</span>
        }
        {
          props.logo && props.logo.length > 0 &&
          <img src={props.logo} height="20px"/>
        } <ChevronDown color={colors.primary} fontWeight={"bold"}/>
      </DropdownToggle>
      <DropdownMenu>
        {/* <DropdownItem>Profile</DropdownItem> */}
        { (user.role == enums.ROLE_ADMIN || user.role == enums.ROLE_SUPER_ADMIN) &&
          <Link className='d-inline' to="/users" style={{textDecoration : 'none'}}><DropdownItem>Create Account</DropdownItem></Link>
        }
        <Link className='d-inline' to="/branches" style={{textDecoration : 'none'}}><DropdownItem>Branches</DropdownItem></Link>
        <DropdownItem onClick={()=>logout()}>Logout</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
}

export default ProfileMenu;